var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-content-center align-items-center" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.inlineEdit || _vm.isEditing,
              expression: "!inlineEdit || isEditing",
            },
          ],
          staticClass: "form-group-material mb-0",
          class: { "assignee-select-single": !_vm.multiple },
          attrs: { id: _vm.id ? _vm.id : "assignee-select-container" },
        },
        [
          _c("h6", { staticClass: "font-xs text-light-gray mb-0" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("global.actions.selectAssignee")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "material-input",
            { attrs: { "no-label": "" } },
            [
              _c("v-select-field", {
                staticClass: "no-span",
                attrs: {
                  options: _vm.vSelectCollaboratorsOptions,
                  scenario: "agents",
                  placeholder: _vm.$t("global.actions.selectAssignee"),
                  multiple: _vm.multiple,
                  clearable: "",
                  "default-value": _vm.timeLineItemCard
                    ? _vm.assigneesSelected
                    : _vm.defaultAssignees,
                },
                on: {
                  "option:selected": _vm.handleChange,
                  "option:deselected": _vm.handleChange,
                  clear: _vm.handleClearAssignee,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "bar" }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.avatarContainerClass,
          on: {
            dblclick: function ($event) {
              _vm.inlineEdit && _vm.setEdit({ edit: true })
            },
          },
        },
        [
          _c("avatar-tooltip", {
            ref: "avatarTooltip",
            attrs: {
              "tooltip-data": _vm.assigneesValues,
              "visible-data": _vm.firstThreeAssignees,
              "empty-message": _vm.$t(
                "client-profile.messages.assigneeEmptyMessage"
              ),
              placement: _vm.tooltipPlacement,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }